export const statusContratoEnum = {
    cidadeEmpreendedoraBasica: 1,
    cidadeEmpreendedora: 2,
};
